import React from 'react';
import { X, Check } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function Comparison() {
  const {
    t
  } = useLanguage();
  const comparisons = [{
    bad: t('comparison.c1Bad'),
    good: t('comparison.c1Good')
  }, {
    bad: t('comparison.c2Bad'),
    good: t('comparison.c2Good')
  }, {
    bad: t('comparison.c3Bad'),
    good: t('comparison.c3Good')
  }, {
    bad: t('comparison.c4Bad'),
    good: t('comparison.c4Good')
  }, {
    bad: t('comparison.c5Bad'),
    good: t('comparison.c5Good')
  }, {
    bad: t('comparison.c6Bad'),
    good: t('comparison.c6Good')
  }, {
    bad: t('comparison.c7Bad'),
    good: t('comparison.c7Good')
  }];
  return <Section className="bg-barber-dark border-y border-barber-lightGray" data-id="element-130">
      <div className="text-center mb-12" data-id="element-131">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-barber-text uppercase mb-4" data-id="element-132">
          {t('comparison.heading1')} <br className="hidden md:block" data-id="element-133" />
          <span className="text-barber-gold" data-id="element-134">{t('comparison.heading2')}</span>
        </h2>
      </div>
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <div className="hidden md:grid grid-cols-2 gap-4 mb-4" data-id="element-136">
          <div className="bg-barber-gray p-4 text-center rounded-t-sm border-b-2 border-barber-red" data-id="element-137">
            <h3 className="font-heading text-xl text-barber-muted uppercase tracking-wider" data-id="element-138">
              {t('comparison.col1')}
            </h3>
          </div>
          <div className="bg-barber-gold/10 p-4 text-center rounded-t-sm border-b-2 border-barber-gold" data-id="element-139">
            <h3 className="font-heading text-xl text-barber-gold font-bold uppercase tracking-wider" data-id="element-140">
              {t('comparison.col2')}
            </h3>
          </div>
        </div>
        <div className="space-y-4 md:space-y-2" data-id="element-141">
          {comparisons.map((item, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4" data-id="element-142">
              <div className="md:hidden bg-barber-gray p-3 text-center rounded-t-sm border-b border-barber-red mt-4 first:mt-0" data-id="element-143">
                <h3 className="font-heading text-sm text-barber-muted uppercase tracking-wider" data-id="element-144">
                  {t('comparison.mob1')}
                </h3>
              </div>
              <div className="bg-barber-black border border-barber-lightGray p-4 md:p-5 flex items-center gap-4 rounded-b-sm md:rounded-sm" data-id="element-145">
                <div className="bg-barber-red/10 p-1.5 rounded-full shrink-0" data-id="element-146">
                  <X className="text-barber-red w-5 h-5" strokeWidth={3} data-id="element-147" />
                </div>
                <p className="text-barber-muted" data-id="element-148">{item.bad}</p>
              </div>
              <div className="md:hidden bg-barber-gold/10 p-3 text-center rounded-t-sm border-b border-barber-gold mt-2" data-id="element-149">
                <h3 className="font-heading text-sm text-barber-gold font-bold uppercase tracking-wider" data-id="element-150">
                  {t('comparison.mob2')}
                </h3>
              </div>
              <div className="bg-barber-gray border border-barber-gold/30 p-4 md:p-5 flex items-center gap-4 rounded-b-sm md:rounded-sm relative overflow-hidden" data-id="element-151">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-barber-gold/5 pointer-events-none" data-id="element-152"></div>
                <div className="bg-barber-gold/20 p-1.5 rounded-full shrink-0 relative z-10" data-id="element-153">
                  <Check className="text-barber-gold w-5 h-5" strokeWidth={3} data-id="element-154" />
                </div>
                <p className="text-barber-text font-medium relative z-10" data-id="element-155">
                  {item.good}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </Section>;
}